module.exports = __webpack_public_path__ + "assets/img/icon_tabnav_02_def.353cb756.png";